import React from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { UsersEditPage } from './UsersEditPage';

/**
 * Wrapper component for UsersEditPage to provide React Router v6 params
 * to the class component that expects React Router v5 props
 */
export function UsersEditPageWrapper(props) {
  const params = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  
  // Create a match object that mimics the React Router v5 match prop
  const match = {
    params,
    path: location.pathname,
    url: location.pathname,
  };
  
  // Create a history object that mimics the React Router v5 history prop
  const history = {
    push: navigate,
    location,
  };
  
  return <UsersEditPage {...props} match={match} history={history} />;
}
